<template>
  <header class="header">
    <h1>
      <a href="/">
        <svg>
          <use xlink:href="/svg/sprite.svg#logo-side" />
        </svg>
      </a>
    </h1>
    <div class="header_search">
      <p class="header_search-word">
        <svg>
          <use xlink:href="/svg/sprite.svg#icon_search" />
        </svg>
        <input type="text" class="text-type01" v-model="k" @blur="setParams" v-on:keyup.enter="setParams"
          placeholder="キーワード検索" />
      </p>
      <p class="header_search-refining">
        <a href="javascript:void(0)" class="btn02 cl_yl" v-on:click="showModal('search-refining')">
          <svg>
            <use xlink:href="/svg/sprite.svg#icon_refine" />
          </svg>
        </a>
      </p>
      <p class="header_search-refining">
        <a href="javascript:void(0)" class="btn02 cl_rd" v-on:click="setFavorite()">
          <svg class="active" v-if="favorite == 1">
            <use xlink:href="/svg/sprite.svg#icon_heart-solid" />
          </svg>
          <svg v-else>
            <use xlink:href="/svg/sprite.svg#icon_heart" />
          </svg>
        </a>
      </p>
    </div>
    <div class="header_navi">
      <p class="header_navi-user">
        <a href="/mypage/">
          <i class="material-icons">account_circle</i>
          {{ user_name }}
        </a>
      </p>
      <ul class="header_navi-menu">
        <li>
          <a href="/wsroot/" target="_blank" class="btn02 cl_lb">
            <i class="material-icons">settings</i>
          </a>
        </li>
      </ul>
      <p class="header_navi-upbtn" v-if="level">
        <a href="/up/" class="btn01 cl_bl">
          <i class="material-icons">file_upload</i>
        </a>
      </p>
    </div>
    <modal name="search-refining" :width="580" :height="700">
      <button v-on:click="hideModal('search-refining')" class="close"></button>
      <div class="modal">
        <div class="modal_box">
          <p class="modal_search-word">
            <svg>
              <use xlink:href="/svg/sprite.svg#icon_search" />
            </svg>
            <input type="text" v-model="k_tag" @keyup="tagNarrow" @blur="tagNarrow" class="text-type01 cl_gr"
              placeholder="キーワードを入力してください" />
          </p>
          <div class="modal_search-column">
            <p class="modal_search-title">絞り込み条件</p>
            <ul class="modal_search-check-list">
              <li>
                <input type="radio" v-model="criteria" value="OR" id="criteria-or" class="check_type03" />
                <label for="criteria-or" class="label_type03">OR</label>
              </li>
              <li>
                <input type="radio" v-model="criteria" value="AND" id="criteria-and" class="check_type03" />
                <label for="criteria-and" class="label_type03">AND</label>
              </li>
            </ul>
          </div>
          <div class="modal_search-box">
            <p class="modal_search-title">事業タグ</p>
            <ul class="modal_search-check-list">
              <li v-for="tag in b_m_tag_pks" :key="tag.pk">
                <input type="checkbox" v-model="chk_b_pks" v-bind:id="tag.pk" v-bind:value="tag.pk"
                  class="check_type01" />
                <label v-bind:for="tag.pk" class="label_type01">
                  {{
                  tag.name
                  }}
                </label>
              </li>
            </ul>
          </div>
          <div class="modal_search-box">
            <p class="modal_search-title">顧客タグ</p>
            <ul class="modal_search-check-list">
              <li v-for="tag in c_m_tag_pks" :key="tag.pk">
                <input type="checkbox" v-model="chk_pe_pks" v-bind:id="tag.pk" v-bind:value="tag.pk"
                  class="check_type01" />
                <label v-bind:for="tag.pk" class="label_type01">
                  {{
                  tag.name
                  }}
                </label>
              </li>
              <!-- li><input type="checkbox" name="tag02" value="タグ01" id="tag02-01" class="check_type01"><label for="tag02-01" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag02" value="タグ02" id="tag02-02" class="check_type01"><label for="tag02-02" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag02" value="タグ03" id="tag02-03" class="check_type01"><label for="tag02-03" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag02" value="タグ04" id="tag02-04" class="check_type01"><label for="tag02-04" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag02" value="タグ05" id="tag02-05" class="check_type01"><label for="tag02-05" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag02" value="タグ06" id="tag02-06" class="check_type01"><label for="tag02-06" class="label_type01">タグ01</label></li-->
            </ul>
          </div>
          <div class="modal_search-box">
            <p class="modal_search-title">検索タグ</p>
            <ul class="modal_search-check-list">
              <li v-for="tag in p_m_tag_pks" :key="tag.pk">
                <input type="checkbox" v-model="chk_p_pks" v-bind:id="tag.pk" v-bind:value="tag.pk"
                  class="check_type01" />
                <label v-bind:for="tag.pk" class="label_type01">
                  {{
                  tag.name
                  }}
                </label>
              </li>
              <!-- li><input type="checkbox" name="tag03" value="タグ01" id="tag03-01" class="check_type01"><label for="tag03-01" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag03" value="タグ02" id="tag03-02" class="check_type01"><label for="tag03-02" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag03" value="タグ03" id="tag03-03" class="check_type01"><label for="tag03-03" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag03" value="タグ04" id="tag03-04" class="check_type01"><label for="tag03-04" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag03" value="タグ05" id="tag03-05" class="check_type01"><label for="tag03-05" class="label_type01">タグ01</label></li>
              <li><input type="checkbox" name="tag03" value="タグ06" id="tag03-06" class="check_type01"><label for="tag03-06" class="label_type01">タグ01</label></li-->
            </ul>
          </div>
          <div class="modal_btnbox">
            <button type="button" class="linebtn cl_pp" v-on:click="dataClear">クリア</button>
            <button type="button" class="btn01 cl_yl" v-on:click="setParams">検索する</button>
          </div>
        </div>
      </div>
    </modal>
  </header>
</template>
<script>
import { Mixin } from "../mixin";
export default {
  name: "Header",
  mixins: [Mixin],
  props: ["Top_query"],
  data() {
    return {
      favorite: this.$route.query.favorite,
      k: "",
      k_tag: "",
      criteria: "AND",
      chk_b_pks: [],
      chk_p_pks: [],
      chk_pe_pks: [],
      b_m_tag_pks: [],
      p_m_tag_pks: [],
      c_m_tag_pks: [],
      all_tags: {
        b_m_tag_pks: [],
        p_m_tag_pks: [],
        c_m_tag_pks: [],
      },
      user_name: this.$cookies.get("lo_name"),
      level: '',
    };
  },
  created() {
    var self = this;
    //タグ取得
    this.getTag().then((result) => {
      if (result) {
        self.level = result.level

        self.b_m_tag_pks = result.b_m_tag_pk;
        self.p_m_tag_pks = result.p_m_tag_pk;
        self.c_m_tag_pks = result.c_m_tag_pk;
        //タブ絞り込みように元データ保存
        for (let key in self.all_tags) {
          eval("self.all_tags." + key + " = self." + key);
        }
      } else {
        //alert('failed.')
      }
    });
    //値復元
    self.k = this.$route.query.k;
    if (this.$route.query.b_m_tag_pk)
      self.chk_b_pks = this.$route.query.b_m_tag_pk.split("-");
    if (this.$route.query.p_m_tag_pk)
      self.chk_p_pks = this.$route.query.p_m_tag_pk.split("-");
    if (this.$route.query.c_m_tag_pk)
      self.chk_pe_pks = this.$route.query.c_m_tag_pk.split("-");
  },
  methods: {
    setParams: function () {
      this.hideModal("search-refining");
      var self = this;
      //全角を半角
      if (self.k) self.k = self.k.replace(/\u3000/g, " ");
      //queryが同じだとNavigationDuplicatedエラーが出るのでquery判断
      const queryStr = this.getParamsStr(
        ["k", "criteria", "favorite", "b_m_tag_pk", "p_m_tag_pk", "c_m_tag_pk"],
        [
          self.k,
          self.criteria,
          self.favorite,
          self.chk_b_pks.join("-"),
          self.chk_p_pks.join("-"),
          self.chk_pe_pks.join("-"),
        ]
      );
      if (queryStr != self.Top_query) {
        //カテゴリ取得
        const category = this.getHashCategory(); //ハッシュから取得
        this.$router.push({
          path: "/",
          query: {
            k: self.k,
            criteria: self.criteria,
            favorite: self.favorite,
            b_m_tag_pk: self.chk_b_pks.join("-"),
            p_m_tag_pk: self.chk_p_pks.join("-"),
            c_m_tag_pk: self.chk_pe_pks.join("-"),
          },
          hash: "c=" + category,
        });
      }
    },
    tagNarrow: function () {
      var self = this;
      self.b_m_tag_pks = self.all_tags["b_m_tag_pks"].filter(function (item) {
        return (
          item.name.indexOf(self.k_tag) > -1 ||
          self.chk_b_pks.indexOf(item.pk) > -1
        );
      });
      self.p_m_tag_pks = self.all_tags["p_m_tag_pks"].filter(function (item) {
        return (
          item.name.indexOf(self.k_tag) > -1 ||
          self.chk_p_pks.indexOf(item.pk) > -1
        );
      });
      self.c_m_tag_pks = self.all_tags["c_m_tag_pks"].filter(function (item) {
        return (
          item.name.indexOf(self.k_tag) > -1 ||
          self.chk_pe_pks.indexOf(item.pk) > -1
        );
      });
    },
    setFavorite: function () {
      var self = this;
      this.hideModal("search-refining");
      const queryStr = new RegExp("favorite=1");
      if (!self.Top_query || !self.Top_query.match(queryStr)) {
        //ON
        self.favorite = 1;
        this.setParams();
      } else {
        //OFF
        self.favorite = 0;
        this.setParams();
      }
    },
    setFavoriteIcon: function () {
      var self = this;
      const queryStr = new RegExp("favorite=1");
      self.favorite = location.search.match(queryStr) ? 1 : 0;
    },
    getParamsStr: function (k_arr, v_arr) {
      var queryArr = [];
      for (var i = 0; k_arr.length > i; i++) {
        if (typeof v_arr[i] !== "undefined")
          queryArr.push(k_arr[i] + "=" + encodeURI(v_arr[i]));
      }
      return "?" + queryArr.join("&", queryArr);
    },
    dataClear: function () {
      var self = this;
      self.k = "";
      self.criteria = "AND";
      self.chk_b_pks = [];
      self.chk_p_pks = [];
      self.chk_pe_pks = [];
    },
  },
};
</script>
